import { useAuth0 } from '@auth0/auth0-react';
import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import MyButton from 'components/MyButton';
import { FormikWizard } from 'formik-wizard-form';
import { getDateFormatForDatePicket } from 'helper/dateFormat';
import PreSchoolService from 'Lib/API/PreSchool/index';
import { uploadFile } from 'pages/Auth/Presigned';
import { bulkClassInformationSchema } from 'pages/ValidationSchema/bulkClassInformationSchema';
import React, { useEffect, useRef, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { useHistory, useParams } from 'react-router-dom';
import "./BulkClassInfo.scss";
import BulkClassInformation from './bulkClassInformation/BulkClassInformation';
import CreateForm from './createForm/CreateForm';

const CreateBulkClass = () => {
  const formikRef = useRef();
  const { id: bulkRegistrationId } = useParams();
  const { push } = useHistory();
  const { getAccessTokenSilently } = useAuth0();

  const dateFormate = getDateFormatForDatePicket();

  const [finished, setFinished] = useState(false);
  const [loading, setLoading] = useState(false);
  const [coverImage, setCoverImage] = useState("");
  const [croppedImage, setCroppedImage] = useState(null);
  const [getClassesLoading, setGetClassesLoading] = useState(false);
  const [classesList, setClassesList] = useState([]);


  const getClassesList = async () => {
    try {
      setGetClassesLoading(true);
      const token = await getAccessTokenSilently();
      const result = await PreSchoolService.getAllClasses(token);
      const classes = result?.payload?.data?.map((item) => ({
        label: item?.class_name,
        value: item?._id,
      }));
      setClassesList(classes);
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong!');
    } finally {
      setGetClassesLoading(false);
    }
  }

  const getBulkClass = async () => {
    try {
      if (formikRef.current) {
        formikRef.current.setFieldValue('loading', true);
      }
      const token = await getAccessTokenSilently();
      const response = await PreSchoolService.getBulkClassById(token, bulkRegistrationId);
      const data = response?.result;
      const classInfo = {
        bulkName: data?.bulkName,
        bulkStartDate: data?.bulkStartDate,
        bulkEndDate: data?.bulkEndDate,
        description: data?.description?.replace(/&lt;/g, '<'),
        classes: data?.classes,
        formId: data?.form,
        requiredFelids: required_form_field,
        background: data?.background,
        requiredFormFields: requiredFields,
        requiredFieldsIds: requiredFieldsIds,
      };
      setCroppedImage(data?.background);
      if (formikRef.current) {
        console.log('formikRef.current: ', formikRef.current);
        formikRef.current.setValues(classInfo);
      }
    } catch (error) {
      toastr.error('Error', 'Something went wrong');
    } finally {
      if (formikRef.current) {
        formikRef.current.setFieldValue('loading', false);
      }
    }
  };

  useEffect(() => {
    getClassesList();
  }, []);

  useEffect(() => {
    if (bulkRegistrationId) {
      getBulkClass();
    }
  }, [bulkRegistrationId, getAccessTokenSilently]);

  const requiredFieldsIds = [
    "7306E1AD-745F-4BEE-829C-71BB380ED61B",
    "99267192-0200-403C-813D-8AF374FE25D0",
    "986AB1B0-19F0-4339-8594-59427982B41D",
    "3A514A2D-58A7-4D33-9BA7-44551E571FD5",
    "F027F052-CDF8-43E8-ADD5-5425F3BCFBAD"

  ]
  const requiredFields = [
    {
      id: "7306E1AD-745F-4BEE-829C-71BB380ED61B",
      element: "TextInput",
      text: "Text Input",
      required: true,
      canHaveAnswer: true,
      canHavePageBreakBefore: true,
      canHaveAlternateForm: true,
      canHaveDisplayHorizontal: true,
      canHaveOptionCorrect: true,
      canHaveOptionValue: true,
      canPopulateFromApi: true,
      field_name: "text_input_06108B97-D7AC-42A5-8167-ECB948331A10",
      label: "First Name",
    },
    {
      id: "99267192-0200-403C-813D-8AF374FE25D0",
      element: "TextInput",
      text: "Text Input",
      required: true,
      canHaveAnswer: true,
      canHavePageBreakBefore: true,
      canHaveAlternateForm: true,
      canHaveDisplayHorizontal: true,
      canHaveOptionCorrect: true,
      canHaveOptionValue: true,
      canPopulateFromApi: true,
      field_name: "text_input_2F6A1BAF-2E0C-46BB-AD2E-617C3364D143",
      label: "Last Name",
    },
    {
      "id": "986AB1B0-19F0-4339-8594-59427982B41D",
      "element": "EmailInput",
      "text": "Email",
      "required": true,
      "canHaveAnswer": true,
      "canHavePageBreakBefore": true,
      "canHaveAlternateForm": true,
      "canHaveDisplayHorizontal": true,
      "canHaveOptionCorrect": true,
      "canHaveOptionValue": true,
      "canPopulateFromApi": true,
      "field_name": "email_input_02B42DD9-B021-4B9A-B0C6-B6FF3B3D8EF2",
      "label": "E-Mail"
    },
    {
      canHaveAlternateForm: true,
      canHaveAnswer: true,
      canHaveDisplayHorizontal: true,
      canHaveOptionCorrect: true,
      canHaveOptionValue: true,
      canHavePageBreakBefore: true,
      canPopulateFromApi: true,
      dirty: false,
      group_name: undefined,
      inline: undefined,
      required: true,
      static: undefined,
      showDescription: undefined,
      id: "3A514A2D-58A7-4D33-9BA7-44551E571FD5",
      element: "TextInput",
      text: "Text Input",
      field_name: "text_input_6D9C70EE-CC8C-4151-B941-032110B6695F",
      label: "Emergency Contact Name"
    },
    {
      canHaveAlternateForm: true,
      canHaveAnswer: true,
      canHaveDisplayHorizontal: true,
      canHaveOptionCorrect: true,
      canHaveOptionValue: true,
      canHavePageBreakBefore: true,
      canPopulateFromApi: true,
      dirty: false,
      group_name: undefined,
      inline: undefined,
      required: true,
      static: undefined,
      id: "F027F052-CDF8-43E8-ADD5-5425F3BCFBAD",
      element: "PhoneNumber",
      text: "Phone Number",
      field_name: "phone_input_B22E7BFA-488A-42A8-942D-59F9AFF66655",
      label: "Emergency Contact Number"
    }
  ]
  const required_form_field = [
    {
      canHaveAlternateForm: true,
      canHaveAnswer: true,
      canHaveDisplayHorizontal: true,
      canHaveOptionCorrect: true,
      canHaveOptionValue: true,
      canHavePageBreakBefore: true,
      canPopulateFromApi: true,
      dirty: true,
      element: 'TextInput',
      field_name: 'text_input_06108B97-D7AC-42A5-8167-ECB948331A10',
      group_name: undefined,
      id: '7306E1AD-745F-4BEE-829C-71BB380ED61B',
      inline: undefined,
      label: 'First Name ',
      required: true,
      showDescription: undefined,
      static: undefined,
      text: 'Text Input',
    },
    {
      canHaveAlternateForm: true,
      canHaveAnswer: true,
      canHaveDisplayHorizontal: true,
      canHaveOptionCorrect: true,
      canHaveOptionValue: true,
      canHavePageBreakBefore: true,
      canPopulateFromApi: true,
      dirty: false,
      element: 'TextInput',
      field_name: 'text_input_2F6A1BAF-2E0C-46BB-AD2E-617C3364D143',
      group_name: undefined,
      id: '99267192-0200-403C-813D-8AF374FE25D0',
      inline: undefined,
      label: 'Last Name ',
      required: true,
      showDescription: undefined,
      static: undefined,
      text: 'Text Input',
    },
    {
      canHaveAlternateForm: true,
      canHaveAnswer: true,
      canHaveDisplayHorizontal: true,
      canHaveOptionCorrect: true,
      canHaveOptionValue: true,
      canHavePageBreakBefore: true,
      canPopulateFromApi: true,
      dirty: false,
      group_name: undefined,
      inline: undefined,
      required: true,
      showDescription: undefined,
      static: undefined,
      id: "986AB1B0-19F0-4339-8594-59427982B41D",
      element: "EmailInput",
      text: "Email",
      field_name: "email_input_02B42DD9-B021-4B9A-B0C6-B6FF3B3D8EF2",
      label: "E-Mail"
    },
    {
      canHaveAlternateForm: true,
      canHaveAnswer: true,
      canHaveDisplayHorizontal: true,
      canHaveOptionCorrect: true,
      canHaveOptionValue: true,
      canHavePageBreakBefore: true,
      canPopulateFromApi: true,
      dirty: false,
      group_name: undefined,
      inline: undefined,
      required: true,
      static: undefined,
      showDescription: undefined,
      id: "3A514A2D-58A7-4D33-9BA7-44551E571FD5",
      element: "TextInput",
      text: "Text Input",
      field_name: "text_input_6D9C70EE-CC8C-4151-B941-032110B6695F",
      label: "Emergency Contact Name"
    },
    {
      canHaveAlternateForm: true,
      canHaveAnswer: true,
      canHaveDisplayHorizontal: true,
      canHaveOptionCorrect: true,
      canHaveOptionValue: true,
      canHavePageBreakBefore: true,
      canPopulateFromApi: true,
      dirty: false,
      group_name: undefined,
      inline: undefined,
      required: true,
      static: undefined,
      id: "F027F052-CDF8-43E8-ADD5-5425F3BCFBAD",
      element: "PhoneNumber",
      text: "Phone Number",
      field_name: "phone_input_B22E7BFA-488A-42A8-942D-59F9AFF66655",
      label: "Emergency Contact Number"
    }
  ];

  const initialValues = {
    bulkName: '',
    bulkStartDate: null,
    bulkEndDate: null,
    description: '',
    cover_image: null,
    classes: [],
    form_name: '',
    form: {},
    formId: '',
    requiredFelids: required_form_field,
    requiredFormFields: requiredFields,
    requiredFieldsIds: requiredFieldsIds,
  };

  const handleCreateBulkClass = async (values) => {
    const data = {
      bulkName: values.bulkName,
      bulkStartDate: values.bulkStartDate,
      bulkEndDate: values.bulkEndDate,
      description: values.description,
      classes: values.classes,
      form: values.formId,
    };
    try {
      setLoading(true);
      const token = await getAccessTokenSilently();
      const newUrl = coverImage
        ? await uploadFile(coverImage, coverImage, token)
        : "";
      if (typeof newUrl.fileName === "string") {
        data.background = newUrl.fileName;
      }
      await PreSchoolService.createBulkClass(token, data);
      toastr.success('Success', 'Bulk Registration created successfully');
      push('/religious-schools?tab=bulk_registration');
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  }

  const handleUpdateBulkClass = async (values) => {
    const data = {
      id: bulkRegistrationId,
      bulkName: values.bulkName,
      bulkStartDate: values.bulkStartDate,
      bulkEndDate: values.bulkEndDate,
      description: values.description,
      classes: values.classes,
      form: values.formId,
    };
    try {
      setLoading(true);
      const token = await getAccessTokenSilently();
      const newUrl = coverImage
        ? await uploadFile(coverImage, coverImage, token)
        : "";
      if (typeof newUrl.fileName === "string") {
        data.background = newUrl.fileName;
      }
      await PreSchoolService.updateBulkClass(token, data);
      toastr.success('Success', 'Bulk Registration updated successfully');
      push('/religious-schools?tab=bulk_registration');
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  }

  const handleNextStep = async (values, currentStepIndex, handleNext) => {
    if (currentStepIndex === 0) {
      const errors = await formikRef.current.validateForm();
      if (errors && Object.keys(errors).length > 0) {
        const newTouched = {};
        if (errors.bulkName) newTouched.bulkName = true;
        if (errors.bulkStartDate) newTouched.bulkStartDate = true;
        if (errors.bulkEndDate) newTouched.bulkEndDate = true;
        if (errors.classes) newTouched.classes = true;
        formikRef.current.setTouched(newTouched);
        const missing = [];
        if (errors.bulkName) missing.push('Bulk Registration Name');
        if (errors.bulkStartDate) missing.push('Bulk Registration Starts');
        if (errors.bulkEndDate) missing.push('Bulk Registration Ends');
        if (errors.classes) missing.push('Classes');
        toastr.info(
          'Validation',
          missing.length > 0
            ? `Please fill the following required fields: ${missing.join(', ')}`
            : 'Please fill all the mandatory fields'
        );
        return;
      }
    }

    if (currentStepIndex === 1) {
      setFinished(true);
      if (bulkRegistrationId) {
        handleUpdateBulkClass(values);
      } else {
        handleCreateBulkClass(values);
      }
    }
    handleNext();
  };


  return (
    <div className="class__container">
      <FormikWizard
        innerRef={formikRef}
        initialValues={initialValues}
        onSubmit={(values) => { }}
        steps={[
          {
            component: (props) =>
              <BulkClassInformation
                coverImage={coverImage}
                setCoverImage={setCoverImage}
                setCroppedImage={setCroppedImage}
                croppedImage={croppedImage}
                classesList={classesList}
                getClassesLoading={getClassesLoading}
                {...props}
              />,
            validationSchema: bulkClassInformationSchema,
          },
          {
            component: CreateForm,
          },
        ]}
      >
        {({
          values,
          errors,
          touched,
          isSubmitting,
          setFieldValue,
          currentStepIndex,
          renderComponent,
          handlePrev,
          handleNext,
          isNextDisabled,
          isPrevDisabled,
          handleSubmit,
          ...props
        }) => {
          return (
            <form onSubmit={handleSubmit}>
              <div className="top_section">
                <div className="header__title">{bulkRegistrationId ? "Edit Bulk" : "Create Bulk"}</div>
                <div className="class__steps">
                  <Stepper activeStep={currentStepIndex}>
                    <Step completed={currentStepIndex > 0} className="step">
                      <StepLabel className="step-label">
                        Bulk Information
                      </StepLabel>
                    </Step>
                    <Step completed={finished}>
                      <StepLabel>Create Parent Form</StepLabel>
                    </Step>
                  </Stepper>
                </div>
                <div className="action__section">
                  <div className="action__buttons d-flex">
                    <MyButton
                      content={currentStepIndex === 0 ? 'Cancel' : 'Previous'}
                      onClick={() => {
                        if (currentStepIndex === 0) {
                          push('/religious-schools?tab=bulk_registration');
                        }
                        else {
                          handlePrev();
                        }
                      }}
                      style={{
                        marginRight: '1rem',
                        borderRadius: '0',
                        color: '#565656',
                        height: '39px',
                        width: '113px',
                        backgroundColor: '#fff',
                      }}
                    />
                    <MyButton
                      content={
                        currentStepIndex === 1 ? (
                          <span>
                            Save
                            {loading && (
                              <span className="ml-3 spinner spinner-gray"></span>
                            )}
                          </span>
                        ) : (
                          'Continue'
                        )
                      }
                      onClick={() =>
                        handleNextStep(values, currentStepIndex, handleNext)
                      }
                      disabled={loading}
                      style={{
                        width: '121px',
                        height: '36px',
                      }}
                    />
                  </div>
                </div>
              </div>
              <Box>{renderComponent()}</Box>
            </form>
          )
        }
        }
      </FormikWizard>
    </div>
  )
}

export default CreateBulkClass